import { FileText } from 'lucide-react';

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-white\">
      {/* Header */}
      <header className="border-b border-slate-200 bg-white sticky top-0 z-10\">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center gap-3\">
          <a href="/\" className="flex items-center gap-2\" data-testid="refund-logo-link\">
            <div className="w-8 h-8 bg-accent rounded-lg flex items-center justify-center\">
              <FileText className="h-4 w-4 text-white\" />
            </div>
            <span className="font-semibold text-slate-900\">Canva For Resume</span>
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16\">
        <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-2\" data-testid="refund-heading\">
          Refund Policy
        </h1>
        <p className="text-sm text-slate-500 mb-10\">Last updated: February 1, 2026</p>

        <div className="prose prose-slate max-w-none space-y-8\" data-testid="refund-content\">
          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">1. Credit Purchases</h2>
            <p className="text-slate-600 leading-relaxed\">
              All credit purchases on Canva For Resume are processed securely through Razorpay. Credits are added to your account immediately upon successful payment confirmation.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">2. Refund Eligibility</h2>
            <p className="text-slate-600 leading-relaxed\">
              We offer refunds under the following circumstances: if credits were charged but not added to your account due to a technical error, if a duplicate payment was processed, or if the service was unavailable and you were unable to use your purchased credits within 30 days.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">3. Non-Refundable Scenarios</h2>
            <p className="text-slate-600 leading-relaxed\">
              Credits that have already been used to download optimized resumes are non-refundable. Dissatisfaction with the AI-generated output does not qualify for a refund, as the service processes each request in good faith using advanced AI models.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">4. How to Request a Refund</h2>
            <p className="text-slate-600 leading-relaxed\">
              To request a refund, please email us at support@tripleninelabs.com with your registered email address, transaction ID, and a brief description of the issue. We will review your request and respond within 3-5 business days.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">5. Refund Processing</h2>
            <p className="text-slate-600 leading-relaxed\">
              Approved refunds will be processed to the original payment method within 5-10 business days. The exact timeline may vary depending on your bank or payment provider. You will receive an email notification once the refund has been initiated.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">6. Technical Issues</h2>
            <p className="text-slate-600 leading-relaxed\">
              If you experience a technical issue where credits are deducted but no PDF is generated, please contact us immediately. We will either restore your credits or provide a refund at your preference.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">7. Contact Us</h2>
            <p className="text-slate-600 leading-relaxed\">
              For any refund-related inquiries, please contact us at support@tripleninelabs.com. Our support team is available Monday through Friday, 10:00 AM to 6:00 PM IST.
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 py-6\">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-sm text-slate-500\">
          &copy;2026 Canva For Resume, a product of Triplenine Labs.
        </div>
      </footer>
    </div>
  );
};

export default RefundPolicy;